import { Injectable } from "@angular/core";
import { locationKind } from "./location-kind.const";
import { containerLoad } from "../shared/container/load-types.const";
import { rateDiscriminator } from "../rate/rate-discriminator.const";
import { quoteType } from "app/quote/quote-form/quote-type.const";

@Injectable({
  providedIn: "root",
})
export class LocationKindService {
  private allOptions = [
    locationKind.port,
    locationKind.railTerminal,
    locationKind.airport,
  ];
  private fclAndLclOptions = [locationKind.port, locationKind.railTerminal];
  private airOptions = [locationKind.airport];
  private roadOptions = [locationKind.roadTerminal];

  public buildLocationKindFilterOptions(
    discriminator: string,
    kind: string,
  ): string[] {
    if (
      kind === locationKind.airport ||
      kind === quoteType.airtariff ||
      discriminator === containerLoad.air
    ) {
      return this.airOptions;
    }

    if (
      discriminator === containerLoad.fcl ||
      discriminator === containerLoad.lcl
    ) {
      return this.fclAndLclOptions;
    }

    if (
      discriminator === rateDiscriminator.ltlPickupDelivery ||
      discriminator === rateDiscriminator.ltl
    ) {
      return this.roadOptions;
    }

    return this.allOptions;
  }

  public buildContainerListOptions(locationKindParam: string): string[] {
    if (
      locationKindParam === locationKind.port ||
      locationKindParam === locationKind.railTerminal
    ) {
      return [containerLoad.fcl, containerLoad.lcl];
    }

    if (locationKindParam === locationKind.airport) {
      return [containerLoad.air];
    }

    if (locationKindParam === locationKind.roadTerminal) {
      return [containerLoad.ltl];
    }
  }
}
